import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function PartnersTeaser() {
  return (
    <section className="bg-ink-950 py-14 sm:py-24" data-testid="partners-teaser-section">
      <div className="container-brox">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-8 border border-copper/30 bg-gradient-to-br from-copper/10 via-ink-900 to-ink-900 p-6 sm:p-12 lg:flex-row lg:items-center">
            <div>
              <p className="eyebrow mb-3">REȚEAUA BROX</p>
              <h2 className="display-title text-3xl sm:text-4xl">
                Ești firmă de meseriași<br />sau furnizor de materiale?
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
                Brox Construct dezvoltă o rețea de profesioniști către care putem distribui proiectele primite,
                în funcție de specializare, zonă și disponibilitate.
              </p>
            </div>
            <Link to="/parteneri" className="btn-primary shrink-0" data-testid="partners-teaser-cta">
              DEVINO PARTENER BROX
              <ArrowUpRight className="h-5 w-5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
